import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function BrandProvenza({ idVariant = '', className }: Props) {
  return (
    <IconBase name="brand-provenza" w={153} h={10} className={className}>
      <path
        d="M8.67834 0.106934H0V9.89303H3.46706V7.43314H9.4595C11.589 7.43314 12.231 5.75399 12.231 4.29945V3.46522C12.231 1.54009 11.5355 0.106934 8.67834 0.106934ZM8.67834 3.9572C8.67834 4.53474 8.41082 4.99463 7.70457 4.99463H3.47776V2.53474H7.44775C8.35732 2.53474 8.67834 2.90907 8.67834 3.57217V3.94651V3.9572Z"
        fill="currentColor"
      />
      <path
        d="M28.8068 0.107056H19.251V9.89315H22.7287V7.3477H27.0091C27.94 7.3477 28.2396 7.68994 28.2396 8.71668V9.89315H31.7067V8.2354C31.7067 6.62042 30.9684 6.2354 30.0695 6.07497V6.04288C31.4606 5.72203 31.7495 4.95197 31.7495 3.63647V3.01615C31.7495 1.26214 31.1289 0.107056 28.8068 0.107056ZM28.3574 3.89315C28.3574 4.59903 28.0577 4.91989 27.2445 4.91989H22.718V2.53486H26.977C27.9293 2.53486 28.3574 2.69529 28.3574 3.5616V3.88246V3.89315Z"
        fill="currentColor"
      />
      <path
        d="M48.5819 0H43.2957C40.5777 0 38.9619 0.673797 38.9619 3.54011V6.45989C38.9619 9.3262 40.5777 10 43.2957 10H48.5819C51.2999 10 52.9158 9.3262 52.9158 6.45989V3.54011C52.9158 0.673797 51.2999 0 48.5819 0ZM49.3631 5.52941C49.3631 6.95187 49.0635 7.48663 47.6403 7.48663H44.2374C42.8142 7.48663 42.5146 6.94118 42.5146 5.52941V4.47059C42.5146 3.25134 42.8142 2.51337 44.4086 2.51337H47.4797C49.0742 2.51337 49.3631 3.26203 49.3631 4.47059V5.52941Z"
        fill="currentColor"
      />
      <path
        d="M70.6256 0.107056H70.1655L66.5486 6.95197L62.9425 0.107056H62.4823H59.6359H59.1758L64.462 9.89315H64.9221H68.1859H68.646L73.9215 0.107056H73.4614H70.6256Z"
        fill="currentColor"
      />
      <path
        d="M83.8733 7.54021V5.97871H90.7539H91.2034V3.94663H90.7539H83.8733V2.37443H91.1606H91.61V0.107056H91.1606H80.8557H80.4062V9.89315H80.8557H91.3318H91.7919V7.54021H91.3318H83.8733Z"
        fill="currentColor"
      />
      <path
        d="M109.822 0.107056H109.362V6.6739L104.13 0.107056H103.669H99.464H99.0039V9.89315H99.464H102.022H102.471V3.32631L107.704 9.89315H108.164H112.38H112.84V0.107056H112.38H109.822Z"
        fill="currentColor"
      />
      <path
        d="M124.717 7.54021V7.51882L131.748 2.46V0.107056H131.288H120.437H119.977V2.46H120.437H126.836V2.48139L119.795 7.54021V9.89315H120.244H131.459H131.908V7.54021H131.459H124.717Z"
        fill="currentColor"
      />
      <path
        d="M147.607 0.107056H143.22L137.891 9.89315H141.711L142.599 8.16053H148.249L149.191 9.89315H153L147.607 0.107056ZM143.733 6.05358L145.413 2.81294L147.136 6.05358H143.733Z"
        fill="currentColor"
      />
    </IconBase>
  )
}

export default BrandProvenza
